import { useRetrieveBoardingPassQuery, useDeleteBoardingPassMutation, useDeleteBoardingPassTemplateMutation, useRetrieveBoardingPassStatisticsQuery } from 'services/boardingPasses';
import { BoardingPass } from 'ui/data-display/Passes/boardingPass';
import { createTemplateDetails } from 'components/reusable/template/details';


export const BoardingPassDetails = createTemplateDetails({
  TemplateRenderer: BoardingPass,
  retrieveHook: useRetrieveBoardingPassQuery,
  retrieveStatisticsHook: useRetrieveBoardingPassStatisticsQuery,
  deletePassHook: useDeleteBoardingPassMutation,
  deleteTemplateHook: useDeleteBoardingPassTemplateMutation,
  baseUrl: '/boarding-passes/',
  i18nNamespace: 'pass',
})